import React from 'react';
import { FiX, FiSmartphone, FiCheckCircle, FiCopy, FiInfo } from 'react-icons/fi';
import { toast } from 'react-toastify';
// Importez votre QR Code ici une fois que vous l'aurez ajouté au dossier assets
// import waveQr from '../assets/wave-qr.png'; 

const PaymentModal = ({ isOpen, onClose, planName, price }) => {
    if (!isOpen) return null;

    const merchantNumber = "77 785 49 84"; // Votre numéro marchand
    const whatsAppNumber = "221777854984"; // Pour envoyer la preuve

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        toast.success("Numéro copié !");
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-75 backdrop-blur-sm z-[999] flex justify-center items-center p-4 transition-all" onClick={onClose}>
            <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden flex flex-col max-h-[90vh]" onClick={(e) => e.stopPropagation()}>
                {/* Header */}
                <div className="bg-gray-900 text-white p-6 relative text-center flex-shrink-0">
                    <button onClick={onClose} className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors bg-white/10 p-1 rounded-full">
                        <FiX size={20} />
                    </button>
                    <h2 className="text-xl font-bold font-poppins mb-1">Paiement Sécurisé</h2>
                    <p className="text-blue-200 text-sm">Abonnement {planName}</p>
                    <div className="mt-4 inline-block bg-white/10 rounded-xl px-6 py-2 border border-white/10">
                        <span className="text-3xl font-extrabold text-white">{(price || 0).toLocaleString('fr-FR')}</span>
                        <span className="text-sm font-medium ml-1">FCFA</span>
                    </div>
                </div>

                {/* Content */}
                <div className="p-6 bg-gray-50 space-y-4 overflow-y-auto custom-scrollbar">
                    {/* Step 1 */}
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
                        <div className="flex items-center mb-3">
                            <span className="w-6 h-6 rounded-full bg-gray-900 text-white flex items-center justify-center text-xs font-bold mr-3 flex-shrink-0">1</span>
                            <h3 className="font-bold text-gray-800 text-sm">Envoyez le montant exact</h3>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <button 
                                onClick={() => handleCopy(merchantNumber)}
                                className="flex flex-col items-center justify-center p-3 border border-gray-200 rounded-xl hover:border-blue-500 hover:bg-blue-50 transition-all group bg-white"
                            >
                                <img src="https://www.wave.com/img/nav-logo.png" alt="Wave" className="h-8 mb-2 object-contain" />
                                <div className="text-center">
                                    <span className="text-xs text-gray-500 block">Envoyer au</span>
                                    <span className="font-bold text-gray-900 text-sm">{merchantNumber}</span>
                                </div>
                            </button>
                            <button 
                                onClick={() => handleCopy(merchantNumber)}
                                className="flex flex-col items-center justify-center p-3 border border-gray-200 rounded-xl hover:border-orange-500 hover:bg-orange-50 transition-all group bg-white"
                            >
                                <img src="https://otobi.sn/wp-content/uploads/2022/03/Orange-Money-logo.png" alt="OM" className="h-8 mb-2 object-contain" />
                                <div className="text-center">
                                    <span className="text-xs text-gray-500 block">Envoyer au</span>
                                    <span className="font-bold text-gray-900 text-sm">{merchantNumber}</span>
                                </div>
                            </button>
                        </div>
                    </div>

                    {/* Step 2 */}
                    <div className="bg-white p-4 rounded-xl shadow-sm border border-gray-200">
                        <div className="flex items-center mb-3">
                            <span className="w-6 h-6 rounded-full bg-gray-900 text-white flex items-center justify-center text-xs font-bold mr-3 flex-shrink-0">2</span>
                            <h3 className="font-bold text-gray-800 text-sm">Activez votre compte</h3>
                        </div>
                        <p className="text-xs text-gray-500 mb-4 pl-9 leading-relaxed">
                            Une fois le transfert effectué, cliquez sur le bouton ci-dessous pour envoyer la preuve (capture d'écran) sur WhatsApp.
                        </p>
                        <a 
                            href={`https://wa.me/${whatsAppNumber}?text=Bonjour%20j'ai%20payé%20${price}%20FCFA%20pour%20le%20plan%20${planName}.%20Voici%20la%20preuve.`} 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="flex items-center justify-center w-full bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold py-3.5 px-4 rounded-xl transition-all shadow-md hover:shadow-lg transform active:scale-95 group"
                        >
                            <FiSmartphone className="mr-2 text-xl group-hover:animate-bounce" /> Envoyer preuve sur WhatsApp
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PaymentModal;